import { makeStyles } from "@mui/styles";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Dialog, DialogContent, IconButton } from "@mui/material";
import { ReactComponent as AlertIcon } from "../../../assets/alert.svg";
import { PrimaryButton, SecondaryButton } from "../Buttons";

const useStyles = makeStyles(() => ({
  dialogContent: {
    width: 460,
    height: 260,
    padding: 16,
  },
  closeIconContainer: {
    height: 40,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  contentContainer: {
    height: "calc(100% - 80px)",
  },
  actionContainer: {
    height: 40,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-evenly",
  },
  alertIconContainer: {
    height: 72,
    padding: "5px 0px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  TextContainer: {
    height: 50,
    padding: 5,
    textAlign: "center",
  },
}));

export default function FlowChangeConfirmationModal({
  cancelHandler,
  cancelText = "Discard",
  contentText = "Are you sure want to discard the changes made?",
  submitHandler,
  submitText = "Save",
  isOpen,
}: any) {
  const classes = useStyles();

  return (
    <Dialog open={isOpen}>
      <DialogContent className={classes.dialogContent}>
        <Box className={classes.closeIconContainer}>
          <IconButton onClick={cancelHandler}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Box className={classes.contentContainer}>
          <Box className={classes.alertIconContainer}>
            <AlertIcon />
          </Box>
          <Box className={classes.TextContainer}>{contentText}</Box>
        </Box>
        <Box className={classes.actionContainer}>
          <SecondaryButton style={{ width: "40%" }} onClick={submitHandler}>
            {submitText}
          </SecondaryButton>
          <PrimaryButton style={{ width: "40%" }} onClick={cancelHandler}>
            {cancelText}
          </PrimaryButton>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
